import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest, postRequest, patchRequest } from 'utilities/service.utils';
import AppService from './app.service.context';

export const fetchEmailsWithCriteria = async (params: any) => {
  const urlBuilder = createUrlBuilder(`/emails/outbound`);
  return await getRequest(AppService, urlBuilder.toString(), params);
};
export const fetchEmailWithDetail = async ({
  direction,
  emailId,
  downloadEmail = false,
  shareId
}: any) => {
  const urlBuilder = createUrlBuilder(`/emails/${direction}/${emailId}`);
  urlBuilder.addParameter('downloadEmail', downloadEmail);
  if (shareId) {
    urlBuilder.addParameter('shareId', shareId);
  }
  return await getRequest(AppService, urlBuilder.toString());
};

export const resendEmails = async ({ emailId }: any) => {
  const urlBuilder = createUrlBuilder(`/emails/outbound/${emailId}/resend`);
  return await postRequest(AppService, urlBuilder.toString(), {});
};

export const resendToOtherEmails = async ({ emailId, emailAddress }: any) => {
  const payload = { destinationEmail: emailAddress };
  const urlBuilder = createUrlBuilder(`/emails/outbound/${emailId}/resend`);
  return await postRequest(AppService, urlBuilder.toString(), payload);
};

export const ignoreEmails = async ({ emailId }: any) => {
  const payload = { isIgnored: true };
  const urlBuilder = createUrlBuilder(`/emails/outbound/${emailId}`);
  const response = await patchRequest(
    AppService,
    urlBuilder.toString(),
    payload
  );
  return response;
};

export const fetchAttachment = async ({ url }: { url: string }) => {
  return await fetch(url);
};
